import React from 'react';

const FileViewer = ({ fileUrl, fileName, filePath }) => {
  // Extract the real extension from the URL or filePath (handles full Supabase URLs)
  const rawPath = filePath || fileUrl || fileName || '';
  // Strip query params before checking extension
  const pathWithoutQuery = rawPath.split('?')[0].toLowerCase();
  const isPdf = pathWithoutQuery.endsWith('.pdf');
  const isImage = /\.(jpeg|jpg|png|gif|webp)$/.test(pathWithoutQuery);
  const isDoc = pathWithoutQuery.endsWith('.docx') || pathWithoutQuery.endsWith('.doc');

  if (isPdf) {
    // Native PDF object rendering — preserves 100% original page top margins and headers without Google Docs top bar cropping
    return (
      <object
        data={`${fileUrl}#toolbar=0&navpanes=0&view=FitH`}
        type="application/pdf"
        className="w-full h-full border-none rounded-lg bg-white"
      >
        <iframe
          src={`https://docs.google.com/viewer?url=${encodeURIComponent(fileUrl)}&embedded=true`}
          title={fileName}
          className="w-full h-full border-none rounded-lg bg-white"
        />
      </object>
    );
  }

  if (isDoc) {
    // Use Microsoft Office Web Viewer for Word files — preserves exact layout, margins, and headers
    const msViewUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;
    const googleViewUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(fileUrl)}&embedded=true`;
    return (
      <iframe
        src={msViewUrl}
        onError={(e) => {
          e.target.src = googleViewUrl;
        }}
        title={fileName}
        className="w-full h-full border-none rounded-lg bg-white"
      />
    );
  }

  if (isImage) {
    return (
      <div className="flex items-center justify-center w-full h-full bg-gray-50 rounded-lg p-2">
        <img
          src={fileUrl}
          alt={fileName}
          className="max-w-full max-h-full object-contain rounded shadow-sm"
        />
      </div>
    );
  }

  // Fallback: unsupported file type — show open link rather than forcing download
  return (
    <div className="flex flex-col items-center justify-center h-full w-full text-center p-8 bg-gray-50 rounded-xl">
      <p className="text-gray-500 mb-4">This file type cannot be previewed directly.</p>
      <a
        href={fileUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#086C53] text-white px-5 py-2.5 rounded font-bold text-[14px] hover:bg-[#065440] transition"
      >
        Open File
      </a>
    </div>
  );
};

export default FileViewer;
